const examScheduleActions = {
    GET_SCHEDULE_COURSES: 'GET_SCHEDULE_COURSES',
    SET_SCHEDULE_COURSES: 'SET_SCHEDULE_COURSES',

    GET_EXAM_SCHEDULE: 'GET_EXAM_SCHEDULE',
    SET_EXAM_SCHEDULE: 'SET_EXAM_SCHEDULE',

    GET_EXAM_PAPERS: 'GET_EXAM_PAPERS',
    SET_EXAM_PAPERS: 'SET_EXAM_PAPERS',

    GET_SCHEDULE_PREVIEW: 'GET_SCHEDULE_PREVIEW',
    SET_SCHEDULE_PREVIEW: 'SET_SCHEDULE_PREVIEW',

    CREATE_SCHEDULE_ROW: 'CREATE_SCHEDULE_ROW',
    UPDATE_SCHEDULE_ROW: 'UPDATE_SCHEDULE_ROW',
    DELETE_SCHEDULE_ROW: 'DELETE_SCHEDULE_ROW',
};

export default examScheduleActions;
